import {
  AvatarCurrency,
  AvatarProps,
  FormAutocompleteField,
  FormAutocompleteFieldProps,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from '@razz-team/ui-web';
import { mapCurrencyToFullName } from '@razz-team/utils';
import { useCallback } from 'react';

export function CurrencyField<
  Multiple extends boolean = false,
  DisableClearable extends boolean = false,
>(props: Omit<FormAutocompleteFieldProps<string, Multiple, DisableClearable>, 'getOptionLabel'>) {
  const getOptionLabel = useCallback(
    (currency: string) => `${currency} • ${mapCurrencyToFullName(currency)}`,
    [],
  );

  const renderAvatar = useCallback((currency: string, avatarProps: Partial<AvatarProps>) => {
    return currency ? <AvatarCurrency currency={currency} {...avatarProps} /> : undefined;
  }, []);

  return (
    <FormAutocompleteField
      {...props}
      getOptionLabel={getOptionLabel}
      renderAvatar={renderAvatar}
      renderOption={(props, currency) => (
        <ListItem {...props} key={currency} disablePadding>
          <ListItemAvatar>
            <AvatarCurrency currency={currency} size={32} />
          </ListItemAvatar>
          <ListItemText>{getOptionLabel(currency)}</ListItemText>
        </ListItem>
      )}
    />
  );
}
